// extracted by css-extract-rspack-plugin
export default {"viewInRoomImage":"_7a61b52d"};